// extracted by mini-css-extract-plugin
module.exports = {"ListItem":"TicketsList_ListItem__1JMIM","ListMobile":"TicketsList_ListMobile__3Q9mF","Tabbar":"TicketsList_Tabbar__ffet_"};